import React from 'react';
import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

type PageLayoutProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

// Simple wrapper for consistent page structure.
// Note: App.tsx already provides padding, so we avoid adding redundant padding here.
export function PageLayout({ children, sx }: PageLayoutProps) {
  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', ...sx }}>
      {children}
    </Box>
  );
}


